export const API_STATUS = {
  SUCCESS: 200,
  CREATED: 201,
  ACCEPED: 202,
  ALREADY_REPORTED: 208,
  UNAUTHORIZED: 401,
  INVAILDCREDENTIALS: 1001,
  NOT_FOUND: 404,
  FORBIDDEN: 422,
  ACCESS_DENIED: 403,
};

/**
 * Api Response erros
 */
export const API_STANDRAD_ERRORS = {
  NETWORK_ERROR: "Internet Error",
};


export const AVAILABILITY_URL = "/api/availability";
export const JOIN_URL = "/api/join";
export const ROOMS_LISTIN_URL = "/api/rooms";
export const GAMELEAVE_URL = "/api/gameleave";
export const GAMEDASHBOARD_URL = "/api/gamedashboard";
export const GAME_DASHBOARD_CARD_CREATE_URL = "/api/game/card/create";